import { Link, useParams } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useSetupRun } from '@/api/setup-runs'
import { RunResults } from '@/components/setup/run-results'

export function RunResultsPage() {
  const { runId } = useParams({ from: '/_authenticated/runs/$runId' })
  const run = useSetupRun(runId)
  return (
    <div className="mx-auto max-w-3xl">
      <Link
        to="/setup"
        className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="size-4" />
        Setup
      </Link>
      <h1 className="mt-3 text-2xl font-bold tracking-tight text-balance">
        {run.data?.title ?? 'Results'}
      </h1>
      {run.data && (
        <p className="text-sm text-muted-foreground">
          Run on{' '}
          {new Date(run.data.created_at).toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric',
          })}
        </p>
      )}
      <div className="mt-6 rounded-xl border bg-card p-4 sm:p-6">
        <RunResults runId={runId} page />
      </div>
    </div>
  )
}
